<!-- main toolbar -->
<mat-toolbar>
  <mat-toolbar-row class="main-toolbar" fxLayout="row" fxLayoutAlign="space-between center" (click)="unlock()">
    <!-- logo -->
    <img (click)="navigate()" src="assets/images/logo.png"/>
  </mat-toolbar-row>
</mat-toolbar>


<mat-drawer-container>
  <!-- menu -->
  <mat-drawer mode="side" opened *ngIf="authService.isLoggedIn">
    <app-menu [user]="authService.user$.value" (logout)="logout()"></app-menu>
  </mat-drawer>

  <!-- app -->
  <mat-drawer-content class="main-container">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>


<!-- footer -->
<app-footer></app-footer>

